import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { Box, Stack, Typography } from 'styles';
import { useTheme } from 'stylesHooks';
import { PaymentDetailsType } from 'types/Payment';
import { useTranslation } from 'utils/translations';
import { getShortDate } from 'utils/utils';

const AdditionalDetails = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: 'dbLabels',
	});
	const theme = useTheme();
	const { paymentDetails } = useSelector((store: RootState) => store.payment);

	const stackGap =
		paymentDetails.detailType === PaymentDetailsType.EOP
			? theme.spacing(2.125)
			: theme.spacing(2.55);

	return (
		<>
			<Stack
				display={'flex'}
				alignItems={'flex-start'}
				flex={'1 0 0'}
				gap={stackGap}
				pt={3}
				pb={2.5}
				px={2.5}
				borderRadius={1}
				bgcolor={theme.palette.white.main}
				height={'100%'}
				justifyContent={'space-between'}
			>
				<Box
					display={'flex'}
					justifyContent={'space-between'}
					alignItems={'center'}
					alignSelf={'stretch'}
				>
					<Typography variant="body">
						{tClientLabels('payment.details.dateOfInvoice')}:
					</Typography>
					<Typography variant="bodyLink">
						{getShortDate(paymentDetails.paymentInfo.invoiceDate)}
					</Typography>
				</Box>
				<Box
					display={'flex'}
					justifyContent={'space-between'}
					alignItems={'center'}
					alignSelf={'stretch'}
				>
					<Typography variant="body">
						{tClientLabels('payment.details.idNumber')}:
					</Typography>
					<Typography variant="bodyLink">
						{paymentDetails.paymentInfo.invoiceNumber}
					</Typography>
				</Box>
				<Box
					display={'flex'}
					justifyContent={'space-between'}
					alignItems={'center'}
					alignSelf={'stretch'}
				>
					<Typography variant="body" width={'40%'}>
						{tClientLabels('payment.details.paymentTerms')}:
					</Typography>
					<Typography variant="bodyLink" textAlign={'right'}>
						{tDbLabels(paymentDetails.paymentInfo.paymentTerms)}
					</Typography>
				</Box>
				<Box
					display={'flex'}
					justifyContent={'space-between'}
					alignItems={'center'}
					alignSelf={'stretch'}
				>
					<Typography variant="body">
						{tClientLabels('payment.details.expiryDate')}:
					</Typography>
					<Typography variant="bodyLink">
						{tDbLabels(paymentDetails.paymentInfo.expiryDate)}
					</Typography>
				</Box>
				<Box
					display={'flex'}
					justifyContent={'space-between'}
					alignItems={'center'}
					alignSelf={'stretch'}
				>
					<Typography variant="body">
						{tClientLabels('payment.details.description')}:
					</Typography>
					<Typography variant="bodyLink">
						{paymentDetails.paymentInfo.service
							? tDbLabels(paymentDetails.paymentInfo.service)
							: '-'}
					</Typography>
				</Box>
			</Stack>
		</>
	);
};

export default AdditionalDetails;
